class SearchForm {
    constructor(element) {
        this.form = element;
        this.reseter = element.querySelector('[data-reset-search]');
        this.input = element.querySelector('[data-search-input]');

        this.init();
    }

    init() {
        this.bindReset();
        this.bindInput();
    }

    bindReset() {
        if (this.reseter) {
            this.reseter.addEventListener('click', (e) => {
                e.preventDefault();
                this.input.value = '';
                this.reseter.classList.remove('_active');
            });
        }
    }

    bindInput() {
        this.input.addEventListener('input', (e) => {
            if (this.reseter) {
                if (e.target.value === '') {
                    this.reseter.classList.remove('_active');
                } else {
                    this.reseter.classList.add('_active');
                }
            }
        })
    }
}

// document.addEventListener('DOMContentLoaded', () => {
//     const searchFormElement = document.querySelectorAll('[data-search-form]');
//     searchFormElement.forEach((element) => {
//         new SearchForm(element);
//     });
// })